export function initResources() {
    const section = document.querySelector('.sdcc-resources')
    if (!section) return
  
    const loadMoreBtn = section.querySelector('.sdcc-resources__load-more')
    if (!loadMoreBtn) return
  
    const isMobile = () => window.innerWidth < 768
    const batchSize = () => isMobile() ? 1 : 2
  
    function getHiddenRows() {
      return [...section.querySelectorAll('.sdcc-resources__row--hidden:not(.sdcc-resources__row--visible)')]
    }
  
    function getHiddenDividers() {
      return [...section.querySelectorAll('.sdcc-resources__divider-row--hidden:not(.sdcc-resources__divider-row--visible)')]
    }
  
    function checkAllVisible() {
      return getHiddenRows().length === 0
    }
  
    function revealNext() {
      const hiddenRows = getHiddenRows()
      const toReveal = hiddenRows.slice(0, batchSize())
  
      toReveal.forEach(( row, i ) => {
        // Only reveal divider on desktop and not before the very first revealed row
        if ( !isMobile() ) {
          const prevSibling = row.previousElementSibling
          if ( prevSibling && prevSibling.classList.contains('sdcc-resources__divider-row--hidden') ) {
            prevSibling.classList.add('sdcc-resources__divider-row--visible')
          }
        }
        row.classList.add('sdcc-resources__row--visible')
      })
  
      if (checkAllVisible()) {
        loadMoreBtn.classList.add('sdcc-resources__load-more--inactive')
        loadMoreBtn.setAttribute('disabled', true)
      }
    }
  
    loadMoreBtn.addEventListener('click', revealNext)
  }